import {Routes} from '@angular/router';
import {authRoutes} from './routes/auth.routes';
import {isSignedInGuard} from './guards/is-signed-in.guard';
import {hasPermissionGuard, loadPermissionsGuard} from './guards/has-permission.guard';

export const routes: Routes = [
  ...authRoutes,
  {
    path: 'app',
    loadComponent: () => import('./layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [isSignedInGuard, loadPermissionsGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      }, {
        path: 'tenants',
        loadComponent: () => import('./pages/tenant/tenant-overview/tenant-overview.component').then(m => m.TenantOverviewComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'tenants:read'},
      }, {
        path: 'tenant/create',
        loadComponent: () => import('./pages/tenant/tenant-create/tenant-create.component').then(m => m.TenantCreateComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'tenants:write'},
      }, {
        path: 'tenant/:id',
        loadComponent: () => import('./pages/tenant/tenant-detail/tenant-detail.component').then(m => m.TenantDetailComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'tenants:read'},
      }, {
        path: 'mandates',
        loadComponent: () => import('./pages/mandates/mandates-overview/mandates-overview.component').then(m => m.MandatesOverviewComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'mandates:read'},
      }, {
        path: 'signing-requests',
        loadComponent: () => import('./pages/signing-requests/signing-requests-overview/signing-requests-overview.component').then(m => m.SigningRequestsOverviewComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'signingRequests:read'},
      },
      {
        path: 'customers',
        loadComponent: () => import('./pages/customers/customers-overview/customers-overview.component').then(m => m.CustomersOverviewComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'customers:read'},
      },
      {
        path: 'api-clients',
        loadComponent: () => import('./pages/api-clients/api-clients-overview/api-clients-overview.component').then(m => m.ApiClientsOverviewComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'apiClients:read'},
      },
      {
        path: 'admin-users',
        loadComponent: () => import('./pages/admin-users/admin-users-overview/admin-users-overview.component').then(m => m.AdminUsersOverviewComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'adminUsers:read'},
      },
      {
        path: 'configuration/tenant-profiles',
        loadComponent: () => import('./pages/configuration/tenant-profiles/tenant-profiles.component').then(m => m.TenantProfilesComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'configuration:read'},
      },
      {
        path: 'unknown-bank-accounts',
        loadComponent: () => import('./pages/unknown-bank-accounts/unknown-bank-accounts-overview/unknown-bank-accounts-overview.component').then(m => m.UnknownBankAccountsOverviewComponent),
        canActivate: [hasPermissionGuard],
        data: {permission: 'unknownBankAccounts:read'},
      },
      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      }
    ]
  }, {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full',
  }
];
